import type { U3147TimeSessionSearchResult } from '../U3147Service';
import { u3147FormatMinutesAsHoursMinutes } from './u3147FormatDuration';

export interface U3147DayGroup {
  workDate: string;
  sessions: U3147TimeSessionSearchResult[];
  totalMinutes: number;
  allExported: boolean;
  hasUnexported: boolean;
}

export function u3147GroupSessionsByDay(rows: U3147TimeSessionSearchResult[]): U3147DayGroup[] {
  const byDate = new Map<string, U3147TimeSessionSearchResult[]>();
  for (const row of rows) {
    const key = (row.workDate ?? '').slice(0, 10);
    if (!key) continue;
    const list = byDate.get(key) ?? [];
    list.push(row);
    byDate.set(key, list);
  }

  return Array.from(byDate.entries())
    .sort(([a], [b]) => b.localeCompare(a))
    .map(([workDate, sessions]) => {
      const sorted = [...sessions].sort((a, b) => (a.startedAt ?? '').localeCompare(b.startedAt ?? ''));
      let totalMinutes = 0;
      let allExported = sorted.length > 0;
      let hasUnexported = false;
      for (const s of sorted) {
        const dm = s.durationMinutes;
        if (typeof dm === 'number' && Number.isFinite(dm)) {
          totalMinutes += dm;
        }
        const exported = !!(s.exportedAt?.trim() || s.exportedTimesheetId?.trim());
        if (!exported && s.endedAt) hasUnexported = true;
        if (!exported) allExported = false;
      }
      return { workDate, sessions: sorted, totalMinutes, allExported, hasUnexported };
    });
}

export function u3147DayGroupTotalLabel(totalMinutes: number): string {
  return u3147FormatMinutesAsHoursMinutes(totalMinutes);
}
